export * from './IconLentaFilled';
